/**
 * Costruisce l'URL del backend basato sull'ambiente.
 * - Su produzione: usa window.location.origin (il frontend è sullo stesso dominio del backend)
 * - Su localhost: usa REACT_APP_BACKEND_HOST configurato nel .env
 *
 * @param {string} endpoint - L'endpoint API (es: '/api/login/', '/api/clubmate/gate-opener')
 * @returns {string} URL completo
 */
export function getLoginUrl(endpoint = '/api/login/') {
  const hostname = window.location.hostname;

  if (hostname !== 'localhost') {
    return window.location.origin + endpoint;
  }

  const backendHost = process.env.REACT_APP_BACKEND_HOST;
  return backendHost + endpoint;
}
